import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { RootState } from "redux/store";
import { fetchIntegrationCalendars } from "redux/slice/integration-calendars";
import { Integration } from "model/integration";
import { getIntegrationCalendarsByIntegrationId } from "redux/selector";
import { EmailCalendarCard } from "./card";
import { EmailCalendarModal } from "./modal";

const mapStateToProps = (state: RootState, ownProps: OwnProps) => ({
	integrationCalendars: getIntegrationCalendarsByIntegrationId(state, ownProps.integration.id),
});
const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ fetchIntegrationCalendars }, dispatch);

interface OwnProps {
	integration: Integration;
}

interface Props extends OwnProps, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {}

interface State {
	modalOpen: boolean;
	calendarId?: string;
}

class Component extends React.Component<Props, State> {

	public constructor(props: Props) {
		super(props);
		this.state = {
			modalOpen: false,
			calendarId: props.integration.data.nylasCalendarId as string || props.integration.data.nylasV3CalendarId as string,
		};
	}

	public componentDidMount() {
		const { integration } = this.props;
		if (!integration.data.nylasCalendarId && !integration.data.nylasV3CalendarId) {
			this.props.fetchIntegrationCalendars({ integrationId: this.props.integration.id });
		}
	}

	public render() {
		const { integration, integrationCalendars } = this.props;
		const { modalOpen, calendarId } = this.state;

		return (
			<>
				<EmailCalendarCard
					integration={integration}
					onViewIntegration={() => this.setState({ modalOpen: true })}
				/>
				<EmailCalendarModal
					open={modalOpen}
					onClose={() => this.setState({ modalOpen: false })}
					integration={integration}
					integrationCalendars={integrationCalendars}
					calendarId={calendarId}
					onCalendarChange={calendarId => this.setState({ calendarId })}
				/>
			</>
		);
	}

}

export const EmailCalendarIntegration = connect(mapStateToProps, mapDispatchToProps)(Component);
